/*
 * Copyright (c) 2026 Gabriele Bonora. Tutti i diritti riservati.
 *
 * Software proprietario. Nessuna licenza d'uso, copia, modifica o distribuzione
 * e' concessa in assenza di autorizzazione scritta del titolare dei diritti.
 * Vedere il file LICENSE nella radice del progetto.
 */
import apiClient from './client';

export const impostazioniAPI = {
  // Pubblica: serve anche prima dell'accesso, per la schermata di login
  leggi: async () => { const { data } = await apiClient.get('/impostazioni'); return data; },

  // Indirizzi delle tre dashboard. Vengono dal .env del server, non dal database:
  // qui si leggono soltanto.
  leggiLink: async () => { const { data } = await apiClient.get('/impostazioni/link'); return data; },

  // Anche i campi operativi (IBAN, SDI, regime fiscale): solo admin
  leggiTutte: async () => { const { data } = await apiClient.get('/impostazioni/tutte'); return data; },

  salva: async (valori) => { const { data } = await apiClient.put('/impostazioni', valori); return data; },

  caricaLogo: async (file) => {
    const fd = new FormData();
    fd.append('logo', file);
    const { data } = await apiClient.post('/impostazioni/logo', fd, {
      headers: { 'Content-Type': 'multipart/form-data' },
    });
    return data;
  },

  rimuoviLogo: async () => { const { data } = await apiClient.delete('/impostazioni/logo'); return data; },

  caricaFavicon: async (file) => {
    const fd = new FormData();
    fd.append('favicon', file);
    const { data } = await apiClient.post('/impostazioni/favicon', fd, {
      headers: { 'Content-Type': 'multipart/form-data' },
    });
    return data;
  },

  rimuoviFavicon: async () => { const { data } = await apiClient.delete('/impostazioni/favicon'); return data; },

  // Icona della singola dashboard: 'cliente', 'tecnico' o 'admin'. Il nome del campo
  // deve combaciare con quello che si aspetta multer sul server.
  caricaIconaArea: async (area, file) => {
    const fd = new FormData();
    fd.append(`icona_${area}`, file);
    const { data } = await apiClient.post(`/impostazioni/icona-area/${area}`, fd, {
      headers: { 'Content-Type': 'multipart/form-data' },
    });
    return data;
  },

  rimuoviIconaArea: async (area) => {
    const { data } = await apiClient.delete(`/impostazioni/icona-area/${area}`);
    return data;
  },
};
